import * as Sentry from '@sentry/react';
import React, { useEffect, useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { removeAttendeeItem } from '../../../../js/api/shopping-cart/_attendees-cart';
import {
  cartAttendeesUpdate,
  updateCartAttendeesAction,
} from '../../../../redux/shopping-cart/shopping-cart.action';

import EditIcons from './images/edit.svg';
import { ReactComponent as DeleteIcons } from './images/delete.svg';
import { ReactComponent as CopyIcons } from './images/copy.svg';
import './assign-attendee-data.styles.scss';

function AssignAttendeeList({
  productTitle,
  sku,
  variantSku,
  setCourseNameForEdit,
  products,
}) {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const cartattendeesArray = useSelector(
    ({ cart }) => cart.cartattendees,
    shallowEqual
  );

  const attendeescountupdate = useSelector(
    ({ cart }) => cart.attendeescount_update,
    shallowEqual
  );

  const [cartAttendeesContent, setcartAttendeesContent] = useState(
    cartattendeesArray
      ? cartattendeesArray.filter(
          (m) => m.VariantSku === variantSku && m.Sku === sku
        )
      : null
  );

  const [hasattendeeUpdate, setHasattendeeUpdate] = useState(false);

  const cartitemimpersonate = useSelector(
    ({ cart }) => cart.impersonateMember,
    shallowEqual
  );

  const handleDelete = async (event) => {
    try {
      const attendeeId = Number(event.target.id);
      let memberId = null;
      if (cartitemimpersonate) {
        memberId = cartitemimpersonate.memberId;
      }
      const data = {
        attendeeid: attendeeId,
        memberid: memberId,
      };

      const preparedData = [].concat.apply(
        [],
        cartattendeesArray.map((e) => e.attendees)
      );

      const attendeeObj = preparedData.filter((m) => m.ID === attendeeId);
      if (attendeeObj && attendeeObj.length > 0) {
        const getcartResponse = await removeAttendeeItem(data);
        if (getcartResponse === 1) {
          // dispatch(cartCountUpdate(1));
          dispatch(cartAttendeesUpdate(1));
        }
      }
    } catch (e) {
      {
        /* RP - Add Sentry Changes */
      }
      Sentry.setExtra('Attendee Page', 'Error in attendee data delete call');
      Sentry.captureException(new Error(e), {
        tags: {
          section: 'Error in attendee data delete call',
        },
      });
    }
  };

  const handleUpdate = async (event) => {
    try {
      dispatch(updateCartAttendeesAction(null));
      const attendeeId = Number(event.target.id);

      const preparedData = [].concat.apply(
        [],
        cartattendeesArray.map((e) => e.attendees)
      );
      const attendeeObj = preparedData.filter((m) => m.ID === attendeeId);

      const filteredCourseData = cartattendeesArray
        .map((e) => {
          const filteredList = e.attendees.filter(
            (inner) => inner.ID === attendeeId
          );

          return {
            courseName: e.CourseName,
            value: filteredList.length,
            variantSku: filteredList.length > 0 && filteredList[0].VariantSku,
          };
        })
        .filter((e) => e.value !== 0)[0];

      setCourseNameForEdit(
        filteredCourseData.courseName,
        filteredCourseData.variantSku
      );
      if (attendeeObj && attendeeObj.length > 0) {
        await dispatch(updateCartAttendeesAction(attendeeObj[0]));
      }
    } catch (e) {
      {
        /* RP - Add Sentry Changes */
      }
      Sentry.setExtra('Attendee Page', 'Error in attendee data update call');
      Sentry.captureException(new Error(e), {
        tags: {
          section: 'Error in attendee data update call',
        },
      });
    }
  };

  const handleCopy = async (event) => {
    try {
      dispatch(updateCartAttendeesAction(null));
      const attendeeId = Number(event.target.id);

      const preparedData = [].concat.apply(
        [],
        cartattendeesArray.map((e) => e.attendees)
      );
      const attendeeObj = preparedData.filter((m) => m.ID === attendeeId);

      const filteredCourseData = cartattendeesArray
        .map((e) => {
          const filteredList = e.attendees.filter(
            (inner) => inner.ID === attendeeId
          );

          return {
            courseName: e.CourseName,
            value: filteredList.length,
            variantSku: filteredList.length > 0 && filteredList[0].VariantSku,
          };
        })
        .filter((e) => e.value !== 0)[0];

      setCourseNameForEdit(
        filteredCourseData.courseName,
        filteredCourseData.variantSku
      );
      if (attendeeObj && attendeeObj.length > 0) {
        const newPreparedObject = { ...attendeeObj[0], ID: '0' };
        await dispatch(updateCartAttendeesAction(newPreparedObject));
      }
    } catch (e) {
      {
        /* RP - Add Sentry Changes */
      }
      Sentry.setExtra('Attendee Page', 'Error in attendee data update call');
      Sentry.captureException(new Error(e), {
        tags: {
          section: 'Error in attendee data update call',
        },
      });
    }
  };

  useEffect(() => {
    setHasattendeeUpdate(false);
    let result = [];
    if (cartattendeesArray) {
      if (variantSku && sku) {
        const hasItem = cartattendeesArray.filter(
          (m) => m.VariantSku === variantSku && m.Sku === sku
        );
        if (hasItem.length > 0) {
          result = hasItem;
        }
      } else {
        const hasItem = cartattendeesArray.filter((m) => m.Sku === sku);
        if (hasItem.length > 0) {
          result = hasItem;
        }
      }
    }
    setcartAttendeesContent(result);
    setHasattendeeUpdate(true);
  }, [
    cartattendeesArray.length,
    attendeescountupdate,
    variantSku,
    JSON.stringify(cartattendeesArray),
  ]);

  const getSessionTypeName = (courseName, variantSku) => {
    const filteredData = products?.filter(
      (e) => e.productTitle === courseName && e.variantsku === variantSku
    )[0];
    return (
      filteredData && {
        sessionTypeName: filteredData.sessionTypeName,
        totalMembers: filteredData.quantity,
      }
    );
  };

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Copy Attendee Information
    </Tooltip>
  );

  const renderEditToolTip = (props) => (
    <Tooltip id="edit-button-tooltip" {...props}>
      Edit Attendee
    </Tooltip>
  );

  const renderDeleteToolTip = (props) => (
    <Tooltip id="delete-button-tooltip" {...props}>
      Delete Attendee
    </Tooltip>
  );

  let warningArray = [];

  warningArray = cartattendeesArray
    ?.filter((e) => {
      const filteredProductData = getSessionTypeName(
        e.CourseName,
        e.VariantSku
      );
      return (
        e.attendees !== undefined &&
        e.attendees.length !== filteredProductData?.totalMembers
      );
    })
    .map((e) => e.CourseName);
  return (
    <div className="assign-attendees-listing-outer">
      <span className="assign-attendee-top-heading">Attendee(s) Data</span>
      {warningArray !== undefined && warningArray.length > 0 && (
        <table>
          <tr>
            <td>
              <span className="assign-attendee-warning">
                <i
                  className="fa fa-exclamation-triangle fa-2x"
                  aria-hidden="true"
                />
              </span>
            </td>
            <td style={{ marginLeft: '5px' }}>
              <span className="assign-attendee-warning">
                Add/omit Attendees for{' '}
                <strong>{warningArray.join(', ')}</strong> to equal Total
                Attendees
              </span>
            </td>
          </tr>
        </table>
      )}
      {cartattendeesArray !== undefined &&
        cartattendeesArray.map((cartAttendee, index) => {
          const filteredProductData = getSessionTypeName(
            cartAttendee.CourseName,
            cartAttendee.VariantSku
          );
          return (
            <div key={index}>
              <hr />
              <span className="assign-attendee-course-name">
                {cartAttendee.CourseName}
              </span>
              <div>
                <span className="assign-attendee-course-sub-name">
                  {filteredProductData ? (
                    <>
                      {filteredProductData.sessionTypeName} -{' '}
                      {`${cartAttendee.attendees.length} of ${filteredProductData.totalMembers} Attendee(s) Added`}
                    </>
                  ) : (
                    <Skeleton />
                  )}
                </span>
              </div>

              {cartAttendee !== undefined &&
                cartAttendee.attendees !== undefined &&
                cartAttendee.attendees.map((item, index) => (
                  <div key={index} className="sub-outer-view">
                    <div className="sub-top-bar">
                      <div className="top-attendee-heading">
                        Attendee #{index + 1}
                      </div>

                      <div>
                        <OverlayTrigger
                          placement="right"
                          delay={{ show: 250, hide: 400 }}
                          overlay={renderEditToolTip}>
                          {/* <EditIcons
                            className="icon-outer-view"
                            onClick={handleUpdate}
                            id={item.ID}
                            style={{ marginRight: '11px' }}
                          /> */}
                          <img
                            id={item.ID}
                            src={EditIcons}
                            alt="edit"
                            onClick={handleUpdate}
                            className="icon-outer-view"
                          />
                        </OverlayTrigger>

                        <OverlayTrigger
                          placement="right"
                          delay={{ show: 250, hide: 400 }}
                          overlay={renderDeleteToolTip}>
                          {/* react icon component not working with current event functions */}
                          {/* <DeleteIcons
                            className="icon-outer-view"
                            id={item.ID}
                            onClick={handleDelete}
                          /> */}
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            id={item.ID}
                            onClick={handleDelete}>
                            <path
                              d="M1.75 3.49984H2.91667M2.91667 3.49984H12.25M2.91667 3.49984L2.91667 11.6665C2.91667 11.9759 3.03958 12.2727 3.25838 12.4915C3.47717 12.7103 3.77391 12.8332 4.08333 12.8332H9.91667C10.2261 12.8332 10.5228 12.7103 10.7416 12.4915C10.9604 12.2727 11.0833 11.9759 11.0833 11.6665V3.49984M4.66667 3.49984V2.33317C4.66667 2.02375 4.78958 1.72701 5.00838 1.50821C5.22717 1.28942 5.52391 1.1665 5.83333 1.1665H8.16667C8.47609 1.1665 8.77283 1.28942 8.99162 1.50821C9.21042 1.72701 9.33333 2.02375 9.33333 2.33317V3.49984M5.83333 6.4165V9.9165M8.16667 6.4165V9.9165"
                              stroke="#2F2F2F"
                              stroke-width="1.6"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              id={item.ID}
                              onClick={handleDelete}
                            />
                          </svg>
                        </OverlayTrigger>
                      </div>
                    </div>

                    <div className="sub-bottom-bar-view">
                      <div className="left-bottom-bar-view">
                        <span className="sub-data-font">{item.FirstName}</span>
                        <span className="sub-data-font">{item.Title}</span>
                        <span className="sub-data-font">
                          {item.EmailAddress}
                        </span>
                        <span className="sub-data-font">{item.Company}</span>
                        {item?.DietaryRestrictionOption === 'y' && (
                          <span className="sub-data-font">
                            {item?.DietaryRestrictionMealOptions &&
                              item?.DietaryRestrictionMealOptions}
                          </span>
                        )}
                      </div>

                      <div className="right-bottom-bar-view">
                        <span className="sub-data-font">{item.Company}</span>
                        <span className="sub-data-font">{item.Address}</span>
                        <span className="sub-data-font">{item.City}</span>
                        <span className="sub-data-font">{item.PostalCode}</span>

                        {item?.DietaryRestrictionOption === 'y' &&
                          item?.DietaryRestrictionMealOptionsOther &&
                          item?.DietaryRestrictionMealOptionsOther !==
                            'None' && (
                            <span
                              className="sub-data-font"
                              style={{ width: '250px' }}>
                              {item?.DietaryRestrictionMealOptionsOther}
                            </span>
                          )}
                      </div>
                    </div>

                    <div className="bottom-copy-bar-view">
                      {/* <div>
                        {item?.DietaryRestrictionOption === 'y' && (
                          <span className="sub-data-font">
                            <CheckIcon fontSize="small" />
                            Dietary Instructions{' '}
                            {item?.DietaryRestrictionMealOptionsOther &&
                              `(${item?.DietaryRestrictionMealOptionsOther})`}
                          </span>
                        )}
                      </div> */}

                      <div>
                        <span
                          id={item.ID}
                          onClick={handleCopy}
                          style={{
                            fontSize: '12px',
                            marginRight: '5px',
                            cursor: 'pointer',
                          }}>
                          Copy Attendee
                        </span>
                        <OverlayTrigger
                          placement="right"
                          delay={{ show: 250, hide: 400 }}
                          overlay={renderTooltip}>
                          <CopyIcons id={item.ID} onClick={handleCopy} />
                        </OverlayTrigger>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          );
        })}
    </div>
  );
}

export default AssignAttendeeList;
